import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { fmtDate } from "@/lib/roles";
import { AppShell } from "@/components/app/AppShell";

const STATUS_CLS = { paid: "bg-emerald-50 text-emerald-700", pending: "bg-amber-50 text-amber-700", expired: "bg-gray-100 text-gray-500" };

export default function AdminPayments() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/payments").then(({ data }) => setRows(data)).catch((e) => { toast.error(formatApiError(e)); setRows([]); });
  }, []);
  const paid = rows?.filter((r) => r.payment_status === "paid") || [];
  const total = paid.reduce((s, r) => s + r.amount, 0);

  return (
    <AppShell eyebrow="— SUPER ADMIN" title="Payments">
      <p className="text-sm text-oath-secondary" data-testid="payments-total">{paid.length} paid · ${total.toLocaleString("en-US", { minimumFractionDigits: 2 })} collected</p>
      <div className="mt-5 overflow-x-auto rounded-2xl border border-gray-200 bg-white">
        <table className="w-full min-w-[820px] text-left text-sm" data-testid="payments-table">
          <thead className="border-b border-gray-200 bg-oath-bg/60 font-mono-label text-[9px] text-oath-muted">
            <tr><th className="px-4 py-3">CUSTOMER</th><th className="px-4 py-3">PACKAGE</th><th className="px-4 py-3">AMOUNT</th><th className="px-4 py-3">STARTED</th><th className="px-4 py-3">STATUS</th></tr>
          </thead>
          <tbody>
            {rows === null && <tr><td colSpan={5} className="px-4 py-8"><Loader2 className="h-5 w-5 animate-spin text-oath-muted" /></td></tr>}
            {rows?.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-oath-muted" data-testid="payments-empty">No payments yet.</td></tr>}
            {rows?.map((r) => (
              <tr key={r.id} className="border-b border-gray-100 last:border-0" data-testid={`payment-row-${r.id}`}>
                <td className="px-4 py-3"><div className="font-medium text-oath-ink">{r.company}</div><div className="text-xs text-oath-secondary">{r.full_name} · {r.email}</div></td>
                <td className="px-4 py-3 text-oath-secondary">{r.description}</td>
                <td className="px-4 py-3 font-mono text-xs">${r.amount.toLocaleString("en-US", { minimumFractionDigits: 2 })}</td>
                <td className="px-4 py-3 font-mono text-xs text-oath-secondary">{fmtDate(r.created_at)}</td>
                <td className="px-4 py-3"><span className={`rounded-full px-2 py-0.5 text-[11px] ${STATUS_CLS[r.payment_status] || STATUS_CLS.pending}`}>{r.payment_status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}
